import React, { useState } from 'react'
import { withAuthProvider } from '../../../lib/auth'

import HeroArea from './Hero'
import RecommendedJobsArea from './RecommendedJobsArea'
import LoadingPlaceholder from './RecommendedJobsArea/Loading'
import CtaSection from './CtaSection'
import NotLoggedInModal from './NotLoggedInModal'
import { StyedWrapper, StyledContainer } from './styles'
import NoPreferencesSet from './RecommendedJobsArea/NoPreferencesSet'

const useModalVisibility = () => {
  const [modalOpen, setModalVisibility] = useState(false)

  const toggleModalVisibility = () => setModalVisibility(!modalOpen)

  return [modalOpen, toggleModalVisibility]
}

export const Dashboard = ({ isLoggedIn, authReady, history }) => {
  const [modalOpen, toggleModalVisibility] = useModalVisibility()

  return (
    <StyedWrapper>
      <HeroArea {...{ history }} />
      <StyledContainer>
        { !authReady
          ? <LoadingPlaceholder />
          : !isLoggedIn
            ? <NoPreferencesSet />
            : <RecommendedJobsArea />
        }
      </StyledContainer>

      <CtaSection {...{ authReady, isLoggedIn }} />
      <NotLoggedInModal
        isOpen={modalOpen}
        toggle={toggleModalVisibility}
      />
    </StyedWrapper>
  )
}

export default withAuthProvider(Dashboard)
